import {Container, Singleton} from "typescript-ioc";
import Device from "@/model/Device";
import StorageKey from "@/storage/StorageKey";
import BizStorage from './BizStorage';
import {LocalStorageWrapper} from "@/storage/StorageWrapper";

@Singleton
export default abstract class DeviceStorage extends BizStorage<Device> {
    protected key = StorageKey.DEVICE
}

class DeviceStorageImpl extends DeviceStorage {
    storage = Container.get(LocalStorageWrapper)
}

Container.bind(DeviceStorage).to(DeviceStorageImpl)
export const deviceStorage = Container.get(DeviceStorage)
